import Marty from "marty";

const GATEWAY_CONSTANTS = Marty.createConstants([
    "STRIPE_CREATE_TOKEN",
    "STRIPE_CREATE_TRANSACTION",
    "STRIPE_SET_ERROR",
    "SHOPIFY_CALLBACK"
]);

export default GATEWAY_CONSTANTS;



/** WEBPACK FOOTER **
 ** ./app/constants/gatewayConstants.js
 **/